export default __webpack_public_path__ + "media/images/icon_tv-07a3241ecdecf3dbd33afc1969d39fd1.svg";